<template>
  <div class="map-component-wrapper">
    <AppOverlay v-model="isSelectedPoiLocationGroup">
      <AppSelectPoiLocationGroupMapModal />
    </AppOverlay>
    <AppOverlay v-if="locationLoading && !isSelectedPoiLocationGroup">
      <AppLoadingSpinner text="地点読み込み中..." class="loading-card" />
    </AppOverlay>
    <div>
      <MainMap
        ref="mainMap"
        :point-list="pointListForUI"
        :has-edit-permission="hasEditPermission"
      />
      <Search v-if="isShowSearch" />
      <MapFooter />
    </div>
    <template v-if="isEditing">
      <v-btn
        v-if="!isMapFullScreen"
        @click="openFullScreenMap"
        icon
        fab
        small
        color="grey lighten-1"
        class="expandBtn"
      >
        <v-icon large color="white">mdi-fullscreen</v-icon>
      </v-btn>
      <v-btn
        v-else
        @click="closeFullScreenMap"
        icon
        fab
        small
        color="grey lighten-1"
        class="expandBtn"
      >
        <v-icon large color="white">mdi-fullscreen-exit</v-icon>
      </v-btn>
    </template>
  </div>
</template>

<script>
import MainMap from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/mapbox/MainMap'
import MapFooter from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/footer/MapFooter'
import Search from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/serach/Search'
import { getters } from '@/vuex/modules/pointGroupOperation/constants'
import { locationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants'

export default {
  name: 'MapComponentWrapper',
  components: {
    MainMap,
    MapFooter,
    Search,
  },
  props: {
    hasEditPermission: {
      type: Boolean,
      default: false,
    },
    isMapFullScreen: {
      type: Boolean,
      default: false,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    locationLoading: {
      type: Boolean,
      default: false,
    },
    isSelectedPoiLocationGroup: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pointListForUI() {
      if (!this.isSelectedPoiLocationGroup)
        return this.$store.getters[getters.pointListForUI]
      return []
    },
    isShowSearch() {
      return (
        this.$store.getters[getters.targetGroup].locationType !==
        locationGroupType.POI_LOCATION
      )
    },
  },
  watch: {
    isMapFullScreen() {
      this.resizeMap()
    },
    isEditing() {
      this.resizeMap()
    },
  },
  methods: {
    openFullScreenMap() {
      this.$emit('open-full-screen')
    },
    closeFullScreenMap() {
      this.$emit('close-full-screen')
    },
    resizeMap() {
      this.$refs.mainMap.resize()
    },
  },
}
</script>

<style scoped lang="scss">
.map-component-wrapper {
  position: relative;
  height: 100%;
  widows: 100%;
}
.expandBtn {
  position: absolute;
  top: 0;
  left: 0;
}
.loading-card {
  flex: 0.3 !important;
}
</style>
